import React from "react";
import { App } from "./App";
import { createRoot } from "react-dom/client";
import { ApolloProvider } from "@apollo/client";
import { hostClient } from "store/graphql/apollo/clients";
import { AppContextProvider } from "store/context/AppContext/AppContext";
import 'ts-widgets/dist/tailwind.css';

const root = createRoot(document.getElementById("app")!);

root.render(
    <ApolloProvider client={hostClient}>
        <AppContextProvider>
            <App />
        </AppContextProvider>
    </ApolloProvider>
);

export { };
